import React, {useState} from 'react'
import BaseButton from "./components/base-components/base-button";
import InputField from "./components/base-components/base-input";
import BaseParagraph from "./components/base-components/base-paragraph";
import BaseRadioBtn from "./components/base-components/base_radio";
import Header from "./components/header/header";
import PhoneInput from "./components/base-components/phone-input";
import LightBox from "./components/base-components/light-box";

import Nn from './assets/png/NN.png'
import {Link} from "react-router-dom";

const StoryBook = () => {
    const [showLightBox, setShowLightBox] = useState(false)

    return (
        <div className="storybook">
            <Header title={"Components list"} back={true} loaded={70}/>


            <br />        <br/>
            <br/>


                <br/>
            <br/>

            Text block component
            <br />

            <BaseParagraph someProperty={"Title"}/>
            <br />
            <br />        <br/>

            Input field component
            <hr/>



            <InputField label={"Input text"}/>
            <InputField label={"Input text"} error={true} errorMessage={"This is an invalid value"} value={"Invalid value"}/>

            <br/>
            <br/>

            Radio button component
            <hr/>
            <BaseRadioBtn  name={"test"} value={"Radio-btn-1"} caption={"Radio btn"}/>

            <br/>
            <br/>
            <br/>

            Checkbox component
            <hr/>

            <InputField type={"checkbox"} checked={true}/>

            <br/>
            <br/>        <br/>


            National Number Input component
            <hr/>

            <InputField label={"National Number"} isNNumber={true}/>

            <BaseButton caption={"Where to find the National Number"} lnk={true} action={()=>{setShowLightBox(true)}}/>
            {showLightBox && <LightBox close={()=>{setShowLightBox(false)}}>

                    <img src={Nn} alt=""/></LightBox> }
            <br/>
            <br/>


            BCE Number Input component
            <hr/>

            <InputField label={"BCE Number"} isBCE={true}/>
            <br/>
            <br/>        <br/>


            Phone Number
            <hr/>


            <PhoneInput />



            <br/>
            <br/>        <br/>


            Button component
            <hr/>
            <br/>

            <BaseButton caption={"Button Normal"}/>
            <BaseButton caption={"Button Outline"} outline={true}/>
            <BaseButton caption={"Button Disabled"} disabled={true}/>
            <br/>
            <br/>
            <br/>        <br/>


                <Link to={'/app'} > Hello4Entrepreneur App </Link>


        </div>
    )
}



export default StoryBook
